import React from 'react';
import { ArrowDown, ArrowUp, Plus, Trash2, X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Checkbox } from './ui/checkbox';
import { RichTextEditor } from './RichTextEditor';

export const newId = () => crypto.randomUUID();

export const TemplateBlockEditor = ({ bloque, index, total, onChange, onMove, onRemove }) => {
  const set = (patch) => onChange({ ...bloque, ...patch });
  const setCampo = (id, label) => set({ campos: bloque.campos.map((c) => (c.id === id ? { ...c, label } : c)) });
  const moveCampo = (i, d) => {
    const cs = [...bloque.campos];
    [cs[i], cs[i + d]] = [cs[i + d], cs[i]];
    set({ campos: cs });
  };
  const t = `tpl-block-${index}`;

  return (
    <div className="rounded-xl border p-4 space-y-3 bg-card" data-testid={t}>
      <div className="flex items-center gap-2">
        <Input value={bloque.titulo} onChange={(e) => set({ titulo: e.target.value })} className="font-semibold" placeholder="Título del bloque" data-testid={`${t}-title`} />
        <Button variant="ghost" size="icon" disabled={index === 0} onClick={() => onMove(-1)} data-testid={`${t}-up`}><ArrowUp className="w-4 h-4" /></Button>
        <Button variant="ghost" size="icon" disabled={index === total - 1} onClick={() => onMove(1)} data-testid={`${t}-down`}><ArrowDown className="w-4 h-4" /></Button>
        <Button variant="ghost" size="icon" onClick={() => window.confirm('¿Eliminar este bloque de la plantilla?') && onRemove()} data-testid={`${t}-delete`}><Trash2 className="w-4 h-4 text-red-600" /></Button>
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">Guion (texto fijo)</Label>
        <RichTextEditor value={bloque.guion_html} onChange={(guion_html) => set({ guion_html })} testId={`${t}-guion`} minHeight={90} sticky={false} />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs uppercase tracking-wide text-muted-foreground">Campos a rellenar</Label>
        {bloque.campos.map((c, i) => (
          <div key={c.id} className="flex items-center gap-1.5">
            <Input value={c.label} onChange={(e) => setCampo(c.id, e.target.value)} className="h-9" data-testid={`${t}-field-${i}`} />
            <Button variant="ghost" size="icon" className="h-8 w-8" disabled={i === 0} onClick={() => moveCampo(i, -1)}><ArrowUp className="w-3.5 h-3.5" /></Button>
            <Button variant="ghost" size="icon" className="h-8 w-8" disabled={i === bloque.campos.length - 1} onClick={() => moveCampo(i, 1)}><ArrowDown className="w-3.5 h-3.5" /></Button>
            <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => set({ campos: bloque.campos.filter((x) => x.id !== c.id) })} data-testid={`${t}-field-${i}-delete`}><X className="w-4 h-4" /></Button>
          </div>
        ))}
        <Button variant="outline" size="sm" onClick={() => set({ campos: [...bloque.campos, { id: newId(), label: 'Nuevo campo' }] })} data-testid={`${t}-add-field`}>
          <Plus className="w-4 h-4 mr-1" />Añadir campo
        </Button>
      </div>
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <Checkbox checked={!!bloque.proximos_pasos} onCheckedChange={(v) => set({ proximos_pasos: !!v })} data-testid={`${t}-next-steps`} />
        Incluir aquí la lista de próximos pasos con fecha
      </label>
    </div>
  );
};
